"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MathRandomizer = exports.FakeRandomizer = void 0;
var assert_1 = __importDefault(require("assert"));
var Percent_1 = require("./Percent");
var FakeRandomizer = /** @class */ (function () {
    function FakeRandomizer(pickedIndex, percent) {
        this.pickedIndex = pickedIndex;
        this.percent = percent;
    }
    FakeRandomizer.create = function () {
        return new FakeRandomizer(0, new Percent_1.Percent(0));
    };
    FakeRandomizer.prototype.alwaysPickItemWithIndex = function (index) {
        return new FakeRandomizer(index, this.percent);
    };
    FakeRandomizer.prototype.alwaysReturn = function (percent) {
        return new FakeRandomizer(this.pickedIndex, percent);
    };
    FakeRandomizer.prototype.pick = function (items) {
        (0, assert_1.default)(items.length > 0, "Can't pick item from an empty list");
        (0, assert_1.default)(items.length >= this.pickedIndex, "Can't pick an item that doesn't exist");
        return items[this.pickedIndex];
    };
    FakeRandomizer.prototype.createPercent = function () {
        return this.percent;
    };
    return FakeRandomizer;
}());
exports.FakeRandomizer = FakeRandomizer;
var MathRandomizer = /** @class */ (function () {
    function MathRandomizer() {
    }
    MathRandomizer.prototype.pick = function (items) {
        (0, assert_1.default)(items.length > 0, "Can't pick item from an empty list");
        var index = Math.floor(Math.random() * items.length);
        (0, assert_1.default)(items.length >= index, "Can't pick item with index ".concat(index));
        return items[index];
    };
    MathRandomizer.prototype.createPercent = function () {
        return Percent_1.Percent.fromDecimal(Math.random());
    };
    return MathRandomizer;
}());
exports.MathRandomizer = MathRandomizer;
